import React, { useState, useEffect } from 'react'
import styles from './styles.module.css'

// component function
export default function SystemStatus() {

	const [status, setStatus] = useState(0)
	const [description, setDescription] = useState('All flowsam systems are operating at normal capacity.')

	// fetch Flowsam system status from Flowsam WordPress site
	useEffect(() => {
		fetch('https://flowsam.ai/wp-json/system/v1/status')
		.then(res => res.json())
		.then(data => {
			if (typeof data === 'object' && data.severity !== undefined && data.description !== undefined && data.description !== '') {
				setStatus(data.severity)
				setDescription(data.description)
			}
		})
		.catch(err => console.error(err))
	}, [])

	return (
		<div className={styles.wrapper}>
			<div className={styles.container}>
				<div className={styles.heading}>Support</div>
				<a href="mailto:support@flowsam.ai" className={styles.cta}>Contact us at support@flowsam.ai</a>
			</div>
			<div className={styles.container}>
				<div className={styles.heading}><span className={styles.status + ' ' + (status === 0 ? styles.statusOk : status === 1 ? styles.statusWarning : styles.statusError)} />System status</div>
				<div className={styles.statusText}>{description}</div>
			</div>
		</div>
	)
}
